import React, { useEffect, useState, useRef, useMemo, Fragment } from "react";
import { Button, Input, Table, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTimes } from '@fortawesome/free-solid-svg-icons';
import './index.scss';
import { useDispatch, useSelector } from "react-redux";
import { documentLogListing } from '../../../../context/actions/document';
import LoaderUI from "../../../../components/common/loader/index";
// import getAdminsList from "../../../../context/actions/admin"
import { getQueue } from "../../../../context/actions/document"
import FilterList from "./FilterList";
import Listing from './Listing'
import NoRecord from '../../../../components/common/NoRecord'


const DocumentLog = ({ }) => {
    const fileData = useSelector((state) => state.document.fileData);
    const docId = fileData?._id;

    const tempItem = [0, 0, 0, 0, 0];

    const dispatch = useDispatch();
    const documentLogs = useSelector((state) => state?.document?.documentLogs)
    let [documentLogDetail, setDocumentLogDetail] = useState(null);


    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState("10");
    const [filter, setFilter] = useState('0')
    const [order, setOrder] = useState(-1);
    let [payload, setPayload] = useState({ page, limit });
    const [showLoader, setShowLoader] = useState(false);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [sort, setSort] = useState('updatedAt');
    const [loader, setLoader] = useState(false);
    const [reload, setReload] = useState(false)

    useEffect(() => {
        setLoader(true);
        dispatch(documentLogListing({ ...payload, page: page, limit: limit, docId: docId, fields: "user", populate: 'user', sort, order, filter: searchKeyword }, (res) => {
            setLoader(false)
        }))
    }, [reload])


    const handleLimit = (val) => {
        setLoader(true);
        console.log('handleLimit value', val)
        setLimit(val);
        setPage(1);
        setPayload({ ...payload, limit: val });
        dispatch(documentLogListing({ ...payload, limit: val, docId: docId, filter: searchKeyword, fields: "user", populate: 'user', sort, order }, (res) => {
            setLoader(false)
        })) // brings DocumentL
    };
    // const handlePageChange = (page) => {
    //     payload = { ...payload, page };

    //     setPage(page);
    //     setShowLoader(true);
    //     dispatch(
    //         getAdminsList(payload, (res) => {
    //             setResPayload(res);
    //             setShowLoader(false);
    //         })
    //     );
    // };?

    const handlePageChange = async (activePage) => {
        setLoader(true);
        console.log('handlePageChange activepage', activePage)
        setPage(activePage)
        // setPayload({ ...payload, page: activePage });
        dispatch(documentLogListing({ ...payload, page: activePage, limit: limit, docId: docId, fields: "user", populate: 'user', sort, order, filter: searchKeyword }, (res) => {
            setLoader(false)
        }))
    };

    const handleFilter = () => {
        setLoader(true)
        dispatch(documentLogListing({ page: 1, limit: limit, docId: docId, filter: searchKeyword, fields: "user", populate: 'user', sort:'updatedAt', order:- 1 }, (res) => {
            setLoader(false)
        }))
        setPage(1)
    };

    const clear = () => {
        setLoader(true)
        setSearchKeyword('')

        dispatch(documentLogListing({ limit: limit, page, docId: docId }, (res) => {
            setLoader(false);
            // setSearchInProgress(false)
        }));
    }

    const sortFn = (params) => {

        setLoader(true);
        setOrder(params?.order)
        setSort(params?.key)
        console.log('params of sortFn', docId)
        let param = { ...params, limit, page: 1, docId: docId, fields: "user", populate: 'user', filter: searchKeyword }
        if (params?.key) {
            param.sort = params?.key
        }
        // if (theKeyword) {
        //     param.keyword = theKeyword
        // } // if we are clear search keyword there should be selcted page
        // param = { ...param }


        // setPayload(param)

        // setShowLoader(true)
        dispatch(documentLogListing(param, (res) => {
            // setPlans(res)
            setLoader(false)
        }));
        setPage(1)
    }

    useEffect(() => {
        console.log('params for useEffect', docId);
        dispatch({ type: "RESET_DOCUMENT_LOGS_LISTING", data: {} });
        setLoader(true)
        dispatch(documentLogListing({ ...payload, limit: limit, page: page, docId: docId, fields: "user", populate: 'user' }, (res) => {
            setLoader(false)
        })) // brings DocumentLog data from database
    }, [])

    // useEffect(() => {
    //     admins();
    // }, [limit]);

    // const admins = () => {
    //     setShowLoader(true);
    //     setSearchInProgress(true);

    //     dispatch(
    //         getAdminsList(payload, (res) => {
    //             setResPayload(res);
    //             setShowLoader(false);
    //             setSearchInProgress(false);
    //         })
    //     );
    // };


    // { handleFilter(e.target.value.trim() && e.target.value.replace(/\./g, "")) }

    return (
        <>
            <div className="file-version-blc d-inline-flex align-items-center text-start">
                <div className="left-col">
                    <a href="#" className='lbl'>
                        {fileData?.folder?.loan_number}
                    </a>
                    {/*<a href="#" className='lbl'>
													{fileData?.folder?.name}
													<span>
														({fileData?.folder?.loan_number})
													</span>
												</a>*/}
                    <span className="arrow-icon">
                        &raquo;
                    </span>
                    <label className='des'>
                        {fileData?.name}
                    </label>
                </div>
            </div>
            <div className="inner">
                <div className='table-wrapper'>

                <FilterList searchKeyword={searchKeyword} _setSearchKeyword={setSearchKeyword} _handleFilter={handleFilter} _clear={clear} reload={reload} _setReload={setReload} />

                    {/* {console.log('documentLogs?.totalCurrentDoc?.length =>', documentLogs)} */}
                    {loader ? <LoaderUI message={false} FullWindow={false} inContainer={true} /> : documentLogs?.docs?.length ? (


                        <div className='table-wrapper'>

                            
                            <Fragment>
                                <div className='card shadow'>
                                    <Listing _sortFn={sortFn} sort={sort} order={order} documentLogs={documentLogs}
                                        page={page} limit={limit} _handleLimit={handleLimit} _handlePageChange={handlePageChange}
                                        documentLogDetail={documentLogDetail} _setDocumentLogDetail={setDocumentLogDetail} fileData={fileData} />
                                </div>
                            </Fragment>
                        </div>)
                        :
                        <div>
                            <div className="card"><NoRecord /></div>
                        </div>
                    }

                </div>
            </div>
        </>

    );
};
export default DocumentLog;